/**
 * 手机号码
 * @param {*} s
 */
 export const isMobile = (phone) => {
    return /^1[3|5|6|7|8|9][0-9]{9}$/.test(phone)
}

/**
 * 邮箱
 * @param {*} s
 */
 export const isEmail = (email) => {
    return /^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/.test(email)
}

/**
 * 身份证
 * @param {*} s
 */
 export const isIdCard = (idCard) => {
    return /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/.test(idCard)
}

/**
 * 数字变数组
 * @param {*} s
 */
export const numToArray= (num) => {
    var str = num + "";
    var resultArr = [];
    for(var i = 0; i < str.length; i++){
        resultArr.push(parseInt(str[i]))
    }
    return resultArr;
}


// WEBPACK FOOTER //
// ./src/utils/utils.js